import React, { useState, memo } from 'react';

const useInputValidator = initialValues => {
  const [value, setValue] = useState(initialValues);

  const handleChange = (name, changeValue,) => {
    setValue({
      ...value,
      [name]: changeValue
    });
  };

  const resetSeatArragement = (val) => {
    setValue(val)
  }

  return {
    value,
    handleChange,
    resetSeatArragement
  };
};

export default useInputValidator;
